const EARTH_RADIUS_METERS = 6371000;

export function toKmPerHour(speedInMetersPerSecond) {
  return Number((Number(speedInMetersPerSecond || 0) * 3.6).toFixed(1));
}

function toRadians(value) {
  return (value * Math.PI) / 180;
}

export function measureDistanceMeters(firstPoint, secondPoint) {
  const latitudeDelta = toRadians(secondPoint.latitude - firstPoint.latitude);
  const longitudeDelta = toRadians(secondPoint.longitude - firstPoint.longitude);
  const latitudeStart = toRadians(firstPoint.latitude);
  const latitudeEnd = toRadians(secondPoint.latitude);

  const haversineValue =
    Math.sin(latitudeDelta / 2) ** 2 +
    Math.cos(latitudeStart) * Math.cos(latitudeEnd) * Math.sin(longitudeDelta / 2) ** 2;

  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(haversineValue));
}

export function getCompassDirection(bearing) {
  if (!Number.isFinite(bearing)) {
    return 'n/d';
  }

  const directions = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSO', 'SO', 'OSO', 'O', 'ONO', 'NO', 'NNO'];
  const normalizedBearing = ((bearing % 360) + 360) % 360;
  const index = Math.round(normalizedBearing / 22.5) % directions.length;
  return directions[index];
}

function formatMeters(distanceMeters) {
  if (!Number.isFinite(distanceMeters)) {
    return 'n/d';
  }

  if (distanceMeters >= 1000) {
    return `${(distanceMeters / 1000).toFixed(2)} km`;
  }

  return `${Math.round(distanceMeters)} m`;
}

function formatSeconds(seconds) {
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return 'n/d';
  }

  if (seconds >= 60) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.round(seconds % 60);
    return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
  }

  return `${Math.round(seconds)}s`;
}

export function inferMovement(currentBus, previousBus) {
  if (!previousBus || !previousBus.timestamp || currentBus.timestamp <= previousBus.timestamp) {
    return {
      status: 'Nuovo nel feed',
      detail: 'Serve almeno un refresh successivo per stimare il movimento',
      direction: getCompassDirection(currentBus.bearing),
      deltaMeters: null,
      deltaSeconds: null,
      estimatedSpeedKmh: null,
    };
  }

  const deltaSeconds = currentBus.timestamp - previousBus.timestamp;
  const deltaMeters = measureDistanceMeters(previousBus, currentBus);
  const estimatedSpeedKmh = Number(((deltaMeters / deltaSeconds) * 3.6).toFixed(1));
  const direction = getCompassDirection(currentBus.bearing);

  if (deltaMeters < 12 || estimatedSpeedKmh < 3) {
    return {
      status: 'Quasi fermo',
      detail: `${formatMeters(deltaMeters)} negli ultimi ${formatSeconds(deltaSeconds)}`,
      direction,
      deltaMeters,
      deltaSeconds,
      estimatedSpeedKmh,
    };
  }

  return {
    status: `In movimento verso ${direction}`,
    detail: `${formatMeters(deltaMeters)} negli ultimi ${formatSeconds(deltaSeconds)}`,
    direction,
    deltaMeters,
    deltaSeconds,
    estimatedSpeedKmh,
  };
}
